module.exports = __webpack_public_path__ + "img/defence-academy-24.3e4a42f0.svg";